<template>
	<div>
		<CRow>
			<CCol col="4">
				<CInput name="name" label="Nom du transporteur" :value="item.name" />
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol sm="6">
				<div class="custom-control custom-switch">
					<input
						name="active"
						type="checkbox"
						class="custom-control-input"
						:id="checkbox1_id"
						:value="true"
						:checked="item.active" />
					<label class="custom-control-label" :for="checkbox1_id">Active</label>
				</div>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import GTreeView from '../../../components/ghostlexly-components/GTreeView';
	import GSwitch from '../../../components/ghostlexly-components/GSwitch';
	import { uniqueId } from 'lodash';

	export default {
		name: 'FormModal',

		components: {
			GSwitch,
			GTreeView,
		},

		props: {
			item: {
				type: Object,
				default: () => {
					return {};
				},
			},
		},

		data() {
			return {
				checkbox1_id: uniqueId('id'),
			};
		},
	};
</script>
